import { useConfig } from 'contexts/ConfigContext';

export const CalorieUnit: React.FC = () => {
  const { currency } = useConfig();

  return currency.toUpperCase() === 'USD' ? <>Cal</> : <>kcal</>;
};
